module.exports = __webpack_public_path__ + "53ff4979b10a5f31f223b3af0c8efb3d.png";